// can-change.js — WHICH ROWS THIS SCREEN LETS YOU CHANGE (INF-14), decided once.
//
// Alex, 2026-09-28: "When internal is working on a project, it is the same thing as
// working on a project." So the rule is keyed on WHERE you are working (the top-bar
// "Working in"), not on who signed in:
//
//     You change a row only if it belongs to what you are working in.
//     Otherwise you copy it.
//
//   Working in Standard → Standard rows change; a project's rows are locked
//                          ("switch Working in to 1001 to change it").
//   Working in 1001     → 1001's rows change; Standard rows are locked ("copy it to
//                          make 1001's own version"). A 1001 login is always here.
//
// A lock here is a CONVENIENCE, not the wall: for project logins the server refuses
// the same writes (catalog-access.js); for internal it prevents the two mistakes the
// selector invites — changing Standard while meaning to work on 1001, and the reverse.
// Promote to Standard stays the one deliberate way up.
//
// ARRANGING — reorder, move, folder (category) edits — is not keyed on Working in:
// folders are shared structure that no project owns, and moves renumber siblings
// across owners. Internal only, until INF-15.
import { createContext, useContext } from 'react';

// { workingIn: '' (Standard) | '<project id>', workingCode: '1001' | null, group }
export const WorkingInContext = createContext({ workingIn: '', workingCode: null, group: 'internal' });

export function lockReason({ ownerProjectId, ownerCode }, { workingIn, workingCode }) {
  const owner = ownerProjectId == null ? '' : String(ownerProjectId);
  if (owner === String(workingIn || '')) return null;
  if (owner === '') {
    return `Standard — copy it to make ${workingCode || 'your project'}'s own version.`;
  }
  const who = ownerCode || 'another project';
  return `Belongs to ${who} — switch Working in to ${who} to change it.`;
}

export function useCanChange() {
  const ctx = useContext(WorkingInContext);
  return {
    // (row fields) => reason string when locked, null when this screen may change it
    lockOwned: (ownerProjectId, ownerCode) => lockReason({ ownerProjectId, ownerCode }, ctx),
    canArrange: ctx.group === 'internal',
    folderLock: ctx.group === 'internal' ? null : 'Folders are shared — only Inoviu can change them.',
  };
}
